<template>
  <div class="dod23" ref="dod23">
    <div class="dod23_content">
      <div class="dod23_text"
      v-bind:style="`background-image: url(${require('@/assets/images/dod/texture_0006.jpg')})`">
        <span>Liquid Retina、登場。iPhone XRの</span><br>
        <span>新しいディスプレイは、業界の中で</span><br>
        <span>最も先進的なLCDです。画期的な</span><br>
        <span>バックライトの設計により、スクリーンを</span><br>
        <span>隅々に広げることができました。</span><br>
        <span>現実の世界に近い色が、一つの美しい</span><br>
        <span>エッジから別の美しいエッジまでを</span><br>
        <span>フルに使って映し出されます。</span>
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'Day23',
  data: () => ({
  }),
  mounted() {
    anime({
      targets: '.dod23_text span',
      color: [
        { value: 'rgba(255,255,255,0)' },
        { value: 'rgba(255,255,255,1)' },
        { value: 'rgba(255,255,255,0)' }
      ],
      duration: 1200,
      loop: true,
      delay: anime.stagger(150),
      easing: 'easeInOutQuad'
    })
  }
}
</script>

<style scoped lang="scss">
.dod23 {
  @include FR_FULLSIZE;
  background-color: #111111;
  color: #ffffff;
}
.dod23_content {
  @include FR_FULLSIZE;
  @include FR_FLEX_LAYOUT(center, center, false, column);
}
.dod23_text {
  @include WEBFONT(normal, bold);
  position: relative;
  font-size: 4vmin;
  font-style: normal;
  line-height: 1.4;
  font-weight: bold;
  -webkit-background-clip: text;
  background-clip: text;
  background-repeat: no-repeat;
  background-color: transparent;
  background-size: 200%;
  background-position: center;
  background-image: linear-gradient(180deg, #FC466B 0%, #3F5EFB 100%);
  color: transparent;
  @supports (font-feature-settings: 'palt' 1) {
    font-feature-settings: 'palt' 1;
    letter-spacing: 0.025em;
  }
}
.dod23_text span {
  color: rgba(255,255,255,0);
}
</style>
